import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CreateReportWizardContainer } from './create-report-wizard-container';

export type CreateReportSidebarMode = 'report' | 'dashboard';

interface CreateReportSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  mode?: CreateReportSidebarMode;
}

export const CreateReportSidebar = ({ isOpen, onClose, mode = 'report' }: CreateReportSidebarProps) => (
  <Sidebar
    header={
      <Typography variant="h2" fontWeight="700">
        {mode === 'dashboard' ? (
          <FormattedMessage id="reporting.create_a_dashboard" defaultMessage="Create a dashboard" />
        ) : (
          <FormattedMessage id="reporting.create_a_report" defaultMessage="Create a report" />
        )}
      </Typography>
    }
    onCancel={onClose}
    open={isOpen}
  >
    <CreateReportWizardContainer onClose={onClose} mode={mode} />
  </Sidebar>
);
